module.exports = __webpack_public_path__ + "img/img5.128e488b.svg";